/** True if the user has asked for reduced motion, or if matchMedia isn't available (SSR). */
export function prefersReducedMotion(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return true;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/** True if the primary input has no hover/fine pointer — used to skip cursor-driven effects. */
export function isCoarsePointer(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return true;
  return window.matchMedia("(pointer: coarse)").matches;
}
